import React  from "react";
import AuthProvider from 'providers/Auth/AuthProvider.jsx';

function AppProviders({children}){
    return (
      <AuthProvider>
          {children}
      </AuthProvider>
    )
}

export default AppProviders;


// WEBPACK FOOTER //
// ./src/providers/App/AppProvider.jsx